import { defaultLocale } from '@adsk/alloy-react-locale';

import { FirstDayOfWeek } from './types';

const HOUR = '([0-1]\\d|[2][0-3])';
const MINUTE = '([0-5]\\d)';
const SECOND = MINUTE;

const DATE = '(\\d{4})-([0]\\d|[1][0-2])-([0-2]\\d|[3][0-1])';
const TIME = `${HOUR}:${MINUTE}(:${SECOND})?(\\.(\\d+))?([+-]${HOUR}:${MINUTE}|[Z])?`;

export const DEFAULT = 'default';
export const SHORT = 'short';
export const LONG = 'long';
export const NUMERIC = 'numeric';

export const VALID_DATE_FORMATS = {
  DEFAULT,
  SHORT,
  LONG,
  NUMERIC,
};

export const ISO_DATE = new RegExp(`^${DATE}[Z]?$`);
export const ISO_DATETIME = new RegExp(`^${DATE}T${TIME}$`);
export const TIME_TOKENS = new Set(['Z', '+', '-']);

type Formats = typeof VALID_DATE_FORMATS;

export type Format = Formats[keyof Formats];

export interface Options {
  /** `'default'`/`'short'` = abbreviated month ('Jan 23, 2015'); `'long'` = full month name ('January 23, 2015'); `'numeric'` = '1/23/2015'. Defaults to `'short'` when omitted. */
  format?: Format;
  hour12?: boolean;
  locale?: string;
  month?: Intl.DateTimeFormatOptions['month'];
  timeZone?: string;
  utc?: boolean;
  weekday?: boolean;
  year?: boolean;
}

export interface RelativeOptions {
  /** `'default'`/`'short'` = abbreviated month; `'long'` = full month name; `'numeric'` = numeric month. Defaults to `'short'` when omitted. */
  format?: Format;
  locale?: string;
}

export interface UseRelativeDateOptions extends RelativeOptions {
  /** When `true`, lowercases the first character of relative-phrase results ("moments ago", "X minutes ago", "today at …", "yesterday at …"). Absolute date results are unaffected. Useful for mid-sentence embedding. Defaults to `false`. */
  lowercase?: boolean;
}

export const VALID_FORMATS = new Set<string | undefined>(
  Object.values(VALID_DATE_FORMATS),
).add(undefined);

export const LOCALE_TO_FIRST_DAY_OF_WEEK: Record<string, FirstDayOfWeek> = {
  'fr-CA': 0,
  da: 1,
  es: 1,
  fi: 1,
  ru: 1,
  'zh-Hans': 1,
  hr: 1,
  fr: 1,
  nl: 1,
  ja: 0,
  ca: 1,
  hu: 1,
  it: 1,
  pl: 1,
  cs: 1,
  'pt-BR': 0,
  'en-GB': 1,
  de: 1,
  ro: 1,
  'zh-Hant': 0,
  ko: 0,
  tr: 1,
  'pt-PT': 0,
  en: 0,
  [defaultLocale]: 0,
  sv: 1,
  no: 1,
  'zh-Hant-HK': 0,
};
